/**
 * Returns the help-center base path including any language prefix.
 * e.g. "/help-center" or "/de/help-center"
 */
export const getHelpCenterBase = () => {
  if (typeof window === "undefined") return "/help-center"
  const path = window.location.pathname
  const idx = path.indexOf("/help-center")
  return idx === -1 ? "/help-center" : path.substring(0, idx + "/help-center".length)
}

/**
 * Extract path information from URL - single source of truth
 * @returns {Object} Object containing path information
 */
export const getPathFromUrl = () => {
  if (typeof window === "undefined")
    return { type: null, slug: null, categoryPath: null }

  const pathString = window.location.pathname

  let contentType = null
  let slug = null
  let categoryPath = null

  if (pathString.includes("/article/")) {
    contentType = "article"

    const articleMatch = pathString.match(/\/article\/([^\/]+)(?:\/|$)/)
    if (articleMatch && articleMatch[1]) {
      slug = articleMatch[1]

      const categoryMatch = pathString.match(
        /\/category\/([^\/]+(?:\/[^\/]+)*)\/article\//
      )
      if (categoryMatch && categoryMatch[1]) {
        categoryPath = categoryMatch[1]
      }
    }
  } else if (pathString.includes("/category/")) {
    contentType = "category"

    const categoryMatch = pathString.match(
      /\/category\/([^\/]+(?:\/[^\/]+)*)(?:\/|$)/
    )
    if (categoryMatch && categoryMatch[1]) {
      categoryPath = categoryMatch[1]
      const segments = categoryPath.split("/")
      slug = segments[segments.length - 1]
    }
  }

  return {
    type: contentType,
    slug,
    categoryPath,
    exactPath:
      contentType === "article"
        ? `${categoryPath}/article/${slug}`
        : categoryPath,
    directParentPath: contentType === "article" ? categoryPath : null,
  }
}
